import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("x1k_token");
    if (!t) { setLoading(false); return; }
    client.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("x1k_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    localStorage.setItem("x1k_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, full_name) => {
    const { data } = await client.post("/auth/register", { email, password, full_name });
    localStorage.setItem("x1k_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("x1k_token");
    setUser(null);
  };

  const refresh = async () => {
    const { data } = await client.get("/auth/me");
    setUser(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
